import React, { useEffect, useState } from 'react';
export function BloodDripEffect() {
  const [drips, setDrips] = useState<Array<{
    id: number;
    left: number;
    delay: number;
    duration: number;
    width: number;
  }>>([]);
  useEffect(() => {
    // Defer blood effect until browser is idle — doesn't block LCP
    const init = () => {
      const newDrips = Array.from({
        length: 12
      }).map((_, i) => ({
        id: i,
        left: i / 12 * 100 + Math.random() * 6,
        delay: Math.random() * 5,
        duration: 4 + Math.random() * 6,
        width: 2 + Math.random() * 4
      }));
      setDrips(newDrips);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(init, {
        timeout: 2000
      });
    } else {
      setTimeout(init, 500);
    }
  }, []);
  if (drips.length === 0) return null;
  return <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden z-0" aria-hidden="true" data-id="element-16">
      {drips.map(drip => <div key={drip.id} className="absolute top-0" style={{
      left: `${drip.left}%`,
      width: `${drip.width}px`,
      height: '100%'
    }} data-id="element-17">
          <div className="w-full rounded-b-full" style={{
        background: 'linear-gradient(to bottom, rgba(139, 0, 0, 0.3), #8b0000, #c0392b)',
        animation: `blood-drip-grow ${drip.duration}s ease-in infinite`,
        animationDelay: `${drip.delay}s`,
        height: 0,
        boxShadow: '0 0 8px rgba(192, 57, 43, 0.6)'
      }} data-id="element-18" />
          <div style={{
        position: 'absolute',
        width: `${drip.width * 2.5}px`,
        height: `${drip.width * 2.5}px`,
        left: '50%',
        marginLeft: `-${drip.width * 1.25}px`,
        backgroundColor: '#c0392b',
        borderRadius: '50%',
        top: 0,
        animation: `blood-drop-fall ${drip.duration}s ease-in infinite`,
        animationDelay: `${drip.delay + drip.duration * 0.7}s`,
        boxShadow: '0 2px 6px rgba(192,57,43,0.8)'
      }} data-id="element-19" />
        </div>)}
    </div>;
}